<script setup lang="ts">
import LayoutContainer from "~/layouts/partials/LayoutContainer.vue"
import AdminDrawerContainer from "~/layouts/partials/AdminDrawerContainer.vue"
import ProfileMenu from "~/components/ProfileMenu.vue"
import ApplicationLogo from "~/components/ApplicationLogo.vue"
import { useModal } from "~/composables/useModal"
import { onMounted } from "vue"
import { useMenuItemSelectedStore } from "~/stores/MenuItemSelected"
import BreadCrumbs from "~/components/BreadCrumbs.vue"
import { useCacheStore } from "~/stores/useCacheStore"

/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const router = useRouter()
const menuItemSelectedStore = useMenuItemSelectedStore()
const initSettingsStore = useDefaultSettingsStore()
const { get } = useOFetchCustom("init-settings")
const cacheStore = useCacheStore()
const { modal: collapseMenu, toggleModal: toggleCollapseMenu } = useModal()

const windowWidth = computed(() => window.innerWidth)

/**
 *
 *  Life cicle events
 *
 *
 */

// onBeforeMount(() => {
//     cacheStore.cleanAll()
// })

onMounted(async () => {
    get(undefined, {
        onSuccess: (res: any) => {
            initSettingsStore.setSettings(res.data)
        },
    })

    const route_name = router.currentRoute.value.name

    if (route_name) {
        menuItemSelectedStore.setByRoute(route_name.toString())
    }
})

/**
 *
 *  Functions section
 *
 *
 */
</script>
<template>
    <LayoutContainer>
        <div class="tw-col-span-12 tw-flex tw-bg-adminAccent-100">
            <div v-if="windowWidth >= 1024">
                <AdminDrawerContainer v-if="!collapseMenu" />
            </div>
            <div class="tw-flex tw-flex-col tw-w-full">
                <nav class="tw-sticky tw-top-0 tw-z-50 lg:tw-relative tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center lg:tw-justify-between lg:tw-gap-4 lg:tw-px-5 lg:tw-py-3 tw-bg-adminPrimary-500">
                    <div class="tw-w-full tw-flex tw-flex-col lg:tw-flex-row lg:tw-items-center tw-gap-4 tw-py-2 lg:tw-py-0">
                        <div class="tw-flex tw-items-center tw-gap-4 tw-px-2 lg:tw-px-0">
                            <q-icon :name="collapseMenu ? 'sym_o_left_panel_open' : 'sym_o_left_panel_close'" size="20px" @click="toggleCollapseMenu" class="tw-cursor-pointer tw-text-adminAccent-200 tw-hidden lg:tw-block" />
                            <NuxtLink to="/">
                                <ApplicationLogo class="tw-w-[120px] tw-h-[20px] tw-mx-auto" />
                            </NuxtLink>
                            <span class="tw-text-adminAccent">{{ $t("admin.title") }}</span>
                            <div class="lg:tw-hidden tw-ml-auto">
                                <ProfileMenu showAdminStyle />
                            </div>
                        </div>
                        <div class="tw-hidden lg:tw-block tw-w-[1px] tw-h-[20px] tw-bg-adminAccent-200"></div>
                        <div class="tw-flex tw-items-center tw-gap-2 tw-overflow-x-auto tw-w-full tw-px-2">
                            <q-icon :name="collapseMenu ? 'sym_o_left_panel_open' : 'sym_o_left_panel_close'" size="20px" @click="toggleCollapseMenu" class="tw-cursor-pointer tw-text-adminAccent-200 lg:tw-hidden" />
                            <slot name="breadCrumbs">
                                <BreadCrumbs />
                            </slot>
                        </div>
                    </div>
                    <div class="tw-hidden lg:tw-block">
                        <ProfileMenu showAdminStyle />
                    </div>
                </nav>
                <div v-if="windowWidth < 1024" class="tw-flex tw-flex-1">
                    <AdminDrawerContainer v-if="!collapseMenu" />
                    <main class="tw-m-1 tw-flex-1 tw-z-10 tw-grid tw-grid-cols-1">
                        <slot></slot>
                    </main>
                </div>
                <main v-else class="lg:tw-m-5 tw-z-10 tw-flex-1 lg:tw-grid lg:tw-grid-cols-1">
                    <slot></slot>
                </main>
            </div>
        </div>
    </LayoutContainer>
</template>
<style>
.shadown {
    box-shadow: 0px 4px 4px 0px rgba(6, 116, 191, 0.15);
}
.body-blur {
    filter: blur(3px);
}
</style>
